import {Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Observable, ReplaySubject} from "rxjs";
import {PartnerFacility} from "../../../shared/interface/partner-facility";
import {Ofwca} from "../../../shared/interface/ofwca";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {delay, startWith, takeUntil, tap} from "rxjs/operators";
import {MatSnackBar} from "@angular/material/snack-bar";
import {KrkAddDialogComponent} from "../../krk/krk-add-dialog/krk-add-dialog.component";
import {Router} from "@angular/router";
import {HttpErrorResponse} from "@angular/common/http";
import {FacilityService} from "../../../shared/services/facility.service";

export interface DialogData {
  ofwcas?: Ofwca[];
  partnerFacility?: PartnerFacility;
}

@Component({
  selector: 'app-facilities-verification-sales-process-add',
  templateUrl: './facilities-verification-sales-process-add.component.html',
  styleUrls: ['./facilities-verification-sales-process-add.component.scss']
})
export class FacilitiesVerificationSalesProcessAddComponent implements OnInit, OnDestroy {

  @Input() partnerFacility?: Observable<PartnerFacility>;
  @Input() ofwcas: Ofwca[] = null;
  @Output() closeModification = new EventEmitter<any>();

  processingRequest = false;
  facilityVerificationSalesProcessForm: FormGroup;
  createdAtControl: FormControl;
  bool0Control: FormControl;
  value0Control: FormControl;
  bool1Control: FormControl;
  value1Control: FormControl;
  bool2Control: FormControl;
  value2Control: FormControl;
  bool3Control: FormControl;
  value3Control: FormControl;
  bool4Control: FormControl;
  value4Control: FormControl;
  bool5Control: FormControl;
  value5Control: FormControl;
  bool6Control: FormControl;
  value6Control: FormControl;
  bool7Control: FormControl;
  value7Control: FormControl;
  bool8Control: FormControl;
  value8Control: FormControl;
  bool9Control: FormControl;
  value9Control: FormControl;
  bool10Control: FormControl;
  value10Control: FormControl;
  bool11Control: FormControl;
  value11Control: FormControl;
  bool12Control: FormControl;
  value12Control: FormControl;
  bool12aControl: FormControl;
  value12aControl: FormControl;
  bool13Control: FormControl;
  value13Control: FormControl;
  value14Control: FormControl;
  value15Control: FormControl;
  bool17Control: FormControl;
  value17Control: FormControl;
  ofwcasControl: FormControl;
  items: Ofwca[] = [];
  facilityObject?: PartnerFacility = null;
  lastSubmittedData: any = null;

  private recommendationMap = {
    bool0: 'Należy zaktualizować klauzulę IDD. OFWCA zobowiązana jest wydrukować klauzulę IDD celem przekazania informacji w niej zawartej Klientowi oraz posiadać wersję elektroniczną celem przekazania informacji w niej zawartej Klientowi obsługiwanemu w sposób zdalny. W przypadku braku możliwości odnalezienia aktualnej klauzuli IDD należy wystąpić do Agenta.',
    bool1: 'Należy zaktualizować pełnomocnictwa agencyjne. OFWCA zobowiązana jest wydrukować je celem przekazania ich Klientowi oraz posiadać wersję elektroniczną celem przekazania jej Klientowi obsługiwanemu w sposób zdalny. W przypadku braku możliwości odnalezienia aktualnych pełnomocnictw należy wystąpić do Agenta.',
    bool2: 'Należy zaktualizować upoważnienia OFWCA. OFWCA zobowiązana jest wydrukować upoważnienia celem przekazania ich Klientowi oraz posiadać wersję elektroniczną celem przekazania jej Klientowi obsługiwanemu w sposób zdalny. W przypadku braku możliwości odnalezienia aktualnych upoważnień należy wystąpić do Agenta.',
    bool3: 'OFWCA zobowiązana jest przekazywać informacje zawarte w klauzuli IDD Klientowi oraz posiadać wersję elektroniczną celem przekazania informacji w niej zawartej Klientowi obsługiwanemu w sposób zdalny.',
    bool4: 'OFWCA zobowiązana jest przekazywać Klientowi pełnomocnictwa agencyjne i upoważnienia oraz posiadać ich wersję elektroniczną celem przekazania Klientowi obsługiwanemu w sposób zdalny.',
    bool5: 'OFWCA zobowiązana jest przed zawarciem umowy ubezpieczenia zbadać wymagania i potrzeby Klienta.',
    bool6: 'OFWCA zobowiązana jest zaktualizować OWU oraz Kartę Produktu do wszystkich produktów posiadanych w sprzedaży.',
    bool7: 'OFWCA zobowiązana jest używać Karty Produktu stanowiącej oddzielny od OWU dokument.',
    bool8: 'OFWCA zobowiązana jest przekazywać Klientowi OWU oraz Kartę Produktu.',
    bool9: 'OFWCA zobowiązana jest przekazywać Klientowi polisę papierową lub w formie innego trwałego nośnika.',
    bool10: 'OFWCA zobowiązana jest przekazywać Klientowi pakiet dokumentów.',
    bool11: 'OFWCA zobowiązana jest archiwizować proces sprzedaży.',
    bool12: '',
    bool12a: 'OFWCA zobowiązana jest stosować procedurę AML.',
    bool17: 'Natychmiastowa blokada dostępów sprzedażowych. Rozwiązanie Umowy współpracy.',
  };
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private snack: MatSnackBar,
    private router: Router,
    private facilityService: FacilityService,
    public dialogRef: MatDialogRef<FacilitiesVerificationSalesProcessAddComponent>,
  ) {
    this.facilityVerificationSalesProcessForm = this.fb.group({
      createdAt: this.createdAtControl = fb.control('', [Validators.required]),
      ofwcas: this.ofwcasControl = fb.control(''),
      bool0: this.bool0Control = fb.control(false),
      value0: this.value0Control = fb.control(this.recommendationMap.bool0),
      bool1: this.bool1Control = fb.control(false),
      value1: this.value1Control = fb.control(this.recommendationMap.bool1),
      value2: this.value2Control = fb.control(this.recommendationMap.bool2),
      bool2: this.bool2Control = fb.control(false),
      value3: this.value3Control = fb.control(this.recommendationMap.bool3),
      bool3: this.bool3Control = fb.control(false),
      value4: this.value4Control = fb.control(this.recommendationMap.bool4),
      bool4: this.bool4Control = fb.control(false),
      value5: this.value5Control = fb.control(this.recommendationMap.bool5),
      bool5: this.bool5Control = fb.control(false),
      value6: this.value6Control = fb.control(this.recommendationMap.bool6),
      bool6: this.bool6Control = fb.control(false),
      value7: this.value7Control = fb.control(this.recommendationMap.bool7),
      bool7: this.bool7Control = fb.control(false),
      value8: this.value8Control = fb.control(this.recommendationMap.bool8),
      bool8: this.bool8Control = fb.control(false),
      value9: this.value9Control = fb.control(this.recommendationMap.bool9),
      bool9: this.bool9Control = fb.control(false),
      bool10: this.bool10Control = fb.control(false),
      value10: this.value10Control = fb.control(this.recommendationMap.bool10),
      bool11: this.bool11Control = fb.control(false),
      value11: this.value11Control = fb.control(this.recommendationMap.bool11),
      bool12: this.bool12Control = fb.control(false),
      value12: this.value12Control = fb.control(this.recommendationMap.bool12),
      bool12a: this.bool12aControl = fb.control(false),
      value12a: this.value12aControl = fb.control(this.recommendationMap.bool12a),
      bool13: this.bool13Control = fb.control(false),
      value13: this.value13Control = fb.control(''),
      value14: this.value14Control = fb.control(''),
      value15: this.value15Control = fb.control(''),
      bool17: this.bool17Control = fb.control(false),
      value17: this.value17Control = fb.control(this.recommendationMap.bool17),

    });
    this.facilityObject = data.partnerFacility;
    this.items = data.ofwcas;
    this.createdAtControl.setValue(new Date());
  }

  ngOnInit(): void {
    const recommendationControls = [
      { boolControl: this.bool0Control, valueControl: this.value0Control, key: 'bool0' },
      { boolControl: this.bool1Control, valueControl: this.value1Control, key: 'bool1' },
      { boolControl: this.bool2Control, valueControl: this.value2Control, key: 'bool2' },
      { boolControl: this.bool3Control, valueControl: this.value3Control, key: 'bool3' },
      { boolControl: this.bool4Control, valueControl: this.value4Control, key: 'bool4' },
      { boolControl: this.bool5Control, valueControl: this.value5Control, key: 'bool5' },
      { boolControl: this.bool6Control, valueControl: this.value6Control, key: 'bool6' },
      { boolControl: this.bool7Control, valueControl: this.value7Control, key: 'bool7' },
      { boolControl: this.bool8Control, valueControl: this.value8Control, key: 'bool8' },
      { boolControl: this.bool9Control, valueControl: this.value9Control, key: 'bool9' },
      { boolControl: this.bool10Control, valueControl: this.value10Control, key: 'bool10' },
      { boolControl: this.bool11Control, valueControl: this.value11Control, key: 'bool11' },
      { boolControl: this.bool12Control, valueControl: this.value12Control, key: 'bool12' },
      { boolControl: this.bool12aControl, valueControl: this.value12aControl, key: 'bool12a' },
      { boolControl: this.bool17Control, valueControl: this.value17Control, key: 'bool17' },
    ];

    recommendationControls.forEach(({ boolControl, valueControl, key }) => {
      boolControl.valueChanges
        .pipe(
          takeUntil(this.destroyed$),
          startWith(false)
        )
        .subscribe((bool: boolean) => {
          const recommendation = this.recommendationMap[key];
          if (bool) {
            // Jeśli bool jest ustawiony na true
            valueControl.setValue('');
          } else {
            // Jeśli bool jest ustawiony na false
            valueControl.setValue(recommendation);
          }
        });
    });

    this.bool13Control.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        startWith(false)
      ).subscribe((bool: boolean) => {
      if (bool) {
        this.value13Control.setValidators([Validators.required]);
        this.value13Control.updateValueAndValidity();
        this.value13Control.enable();
      } else {
        this.value13Control.setValidators([]);
        this.value13Control.updateValueAndValidity();
        this.value13Control.disable();
      }
    });

    this.bool12Control.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        startWith(false)
      )
      .subscribe((bool: boolean) => {
        if (bool) {
          this.value12aControl.enable();
          this.bool12aControl.enable();
        } else {
          this.value12aControl.disable();
          this.bool12aControl.disable();
          this.value12aControl.reset();
          this.bool12aControl.reset();
          this.value12aControl.setValue('');
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  sendForm(): void {
    if (this.value14Control.disabled) {
      this.value14Control.enable();
    }
    if (!this.facilityVerificationSalesProcessForm.valid) {
      this.facilityVerificationSalesProcessForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }

    if (this.processingRequest) {
      return;
    }

    // Sprawdzenie, czy dane są takie same jak poprzednio wysłane
    const currentData = this.facilityVerificationSalesProcessForm.value;
    if (this.lastSubmittedData && JSON.stringify(this.lastSubmittedData) === JSON.stringify(currentData)) {
      this.snack.open('Ten sam obiekt już został wysłany', '', {
        duration: 2000,
      });
      return;
    }

    this.processingRequest = true;

    this.facilityService.addFacilityVerificationSalesProcesss(this.facilityObject.address.uuid, currentData)
      .subscribe({
        next: (response) => {
          this.snack.open('Pomyślnie dodano formularz', '', {
            duration: 2000,
          });
          this.dialogRef.close({
            success: true,
            apiResponse: response,
          });
        },
        error: (error: HttpErrorResponse) => {
          this.processingRequest = false;
          if (error.error?.error?.text) {
            this.snack.open(error.error.error.text, '400', { duration: 4000 });
          } else {
            this.snack.open('Podczas aktualizacji formularza wystąpił błąd', error.status.toString(), {
              duration: 2000,
            });
          }
        },
        complete: () => {
        }
      });
  }

  closeDialog(e): void {
    this.processingRequest = false;
    this.dialogRef.close(e);
  }

}
